import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { useSite } from "@/lib/site";

export const FAQSection = () => {
  const { content } = useSite();
  const faqs = content.faqs || [];
  if (!faqs.length) return null;

  return (
    <section id="faqs" data-testid="faqs-section" className="py-20 sm:py-28">
      <div className="mx-auto max-w-4xl px-4 sm:px-8">
        <Reveal className="text-center">
          <Eyebrow>Good questions, honest answers</Eyebrow>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-ink">
            Frequently asked <span className="italic text-terra">questions.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15} className="mt-12">
          <Accordion
            type="single"
            collapsible
            className="space-y-3"
            onValueChange={(v) => {
              const i = Number(String(v || "").replace("faq-", ""));
              if (v && faqs[i]?.question) window.__tblTrack?.("faq_open", { question: faqs[i].question });
            }}
          >
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.id || i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-ink/10 bg-white px-6 transition-colors duration-300 data-[state=open]:border-terra/40"
              >
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="py-5 text-left font-display text-lg font-semibold text-ink hover:no-underline [&[data-state=open]>svg]:text-terra"
                >
                  {f.question}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-answer-${i}`} className="pb-5 text-sm leading-relaxed text-plumsoft">
                  {f.answer}
                  {f.article_slug && (
                    <Link
                      data-testid={`faq-article-link-${i}`}
                      to={`/blog/${f.article_slug}`}
                      className="mt-3 flex w-fit items-center gap-1.5 font-outfit text-xs font-semibold uppercase tracking-wider text-terra transition-colors hover:text-terradark"
                    >
                      Read the full guide <ArrowRight className="h-3.5 w-3.5" />
                    </Link>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
